import {ReactElement} from 'react';

type TBallProps = {
  index: number;
};
const Ball = ({index}: TBallProps) => {
  const duration = index % 2 ? '0.35s' : '0s';
  const animation = ['beatloader', '0.7s', duration, 'infinite', 'linear'].join(
    ' ',
  );
  return (
    <div
      className="m-[9px] inline-block h-[24px] w-[24px] rounded-full bg-seafoam-200"
      style={{animation, animationFillMode: 'both'}}
    />
  );
};

const BeatLoader = (): ReactElement => {
  return (
    <div>
      <Ball index={0} />
      <Ball index={1} />
      <Ball index={2} />
    </div>
  );
};

export default BeatLoader;
